import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { each, find, isEmpty, includes, filter } from 'lodash';
import {
  checkResult,
  checkTimeout,
  createSummary, updateSummary
} from '../summary-panel/http-helpers';
import Http from '../../../../common/http';
import { IndexData } from "../index-context";
import SummaryEditor from "./summaryEditor";
import WithData from './withData';
import NoData from './noData';

const SummaryItem = ({ title, region, metric, onGotSummary, className }) => {
  const {
    data, aiSummaries, setAiSummaries, jidsRef,
    summaryProgressList, setSummaryProgressList, globalJids,
    setGlobalJids
  } = useContext(IndexData);

  const [ disabled, setDisabled ] = useState(false);
  const [ showModalForm, setShowModalForm ] = useState(false);

  const [ attempt, setAttempt ] = useState(0);
  const attemptRef = useRef(attempt);
  attemptRef.current = attempt;

  const summariesRef = useRef(aiSummaries);
  summariesRef.current = aiSummaries;

  const storageKey = `region_${region.id}`;

  const summary = find(aiSummaries, (summary) => summary.concept_region_id === region.id);

  const inProgress = includes(summaryProgressList, storageKey) || !!summary && !!summary.jid;

  const runAI = () => {
    setAttempt(0);
    setSummaryProgressList([ ...summaryProgressList, storageKey ]);
    const regionMetric = { ...metric, tag: storageKey };

    createSummary(
      regionMetric,
      (http) => { check(http.data); },
      () => { clearStorage(); },
      { concept_region_id: region?.id }
    );
  };

  const update = (params) => {
    setDisabled(true);
    Http.put(`/express/api/ai_summaries/${summary.id}`, params).then(
      (http) => {
        if (http.response.status === 200) {
          if (showModalForm) {
            setShowModalForm(false);
          }
          if ('summary' in params) {
            summary.summary = params.summary;
          }
          if ('add_to_report' in params) {
            summary.add_to_report = params.add_to_report;
          }
          if ('raw_data' in params) {
            summary.raw_data = http.data.record.raw_data;
            summary.raw_data_hashes = http.data.record.raw_data_hashes;
            data.ai_summaries = aiSummaries;
          }
          summary.edited_at_by = http.data.record.edited_at_by;
          setAiSummaries([ ...aiSummaries ]);
        }
        setDisabled(false);
      },
      (reject) => {
        console.log('something went wrong', reject);
      }
    );
  };

  const clearStorage = () => {
    setSummaryProgressList(filter(summaryProgressList, (item) => item !== storageKey));
  };

  const check = (data) => {
    if (!isEmpty(globalJids)) {
      jidsRef.current.push(data);
      return;
    }

    jidsRef.current.push(data);
    setTimeout(() => {
      checkResult(
        jidsRef.current,
        setAttempt, attemptRef, aiSummaries, setAiSummaries, clearStorage,
        { onGotSummary, unlimitedMaxAttempts: true, setSummaryProgressList, setGlobalJids, jidsRef }
      );
    }, checkTimeout);
  };

  useLayoutEffect(() => {
    if (summary?.jid && !summaryProgressList.includes(storageKey)) {
      setSummaryProgressList((prev) => [ ...prev, storageKey ]);
      setAttempt(0);
      check({
        id: summary.id,
        jid: summary.jid,
        tag: storageKey
      });
    }
  }, [ ]);

  const handleUpdateSummary = () => {
    setAttempt(0);
    setSummaryProgressList([ ...summaryProgressList, storageKey ]);

    updateSummary(
      summary.id,
      (http) => { check(http.data); },
      () => { clearStorage(); },
      { tag: `region_${region.id}` }
    );
  };

  const handleEditClick = () => {
    setShowModalForm(true);
  };

  const cancelModal = () => {
    setShowModalForm(false);
  };

  const saveModalData = (newSummary) => {
    const result = {};
    each(newSummary, (el, index) => {
      result[index] = JSON.stringify(el);
    });

    update({ raw_data: result });
  };

  return (
    <li>
      { inProgress && <NoData regionName={ title } text="Working ..." working />}

      { !inProgress && !summary &&
        <>
          <NoData regionName={ title } text={ `${title} summary was not created yet.` } runAI={ runAI } />
        </>}

      { !inProgress && summary &&
        <WithData
          title={ `BuzzIQ Summary - ${title}` }
          summary={ summary }
          handleOnChange={ (v) => {update({ add_to_report: v });} }
          handleUpdateSummary={ handleUpdateSummary }
          handleEditClick={ handleEditClick }
          disabled={ disabled }
          region={ region }
          className={ className }
        />}

      {
        showModalForm &&
        <SummaryEditor
          cancelModal={ cancelModal }
          saveModalData={ saveModalData }
          disabled={ disabled }
          summaryDataInit={ summary }
          deleteClassName="-danger"
        />
      }
    </li>
  );
};

export default SummaryItem;
